import type { EditorAction } from './editorState';

/** Actions permitted when `readOnly` public share is active — view toggles
 *  only, no document / iteration / dialog mutations. */
export const VIEW_ONLY_EDITOR_ACTIONS = new Set<EditorAction['type']>([
  'SET_VIZ',
  // A viewer of a shared room gets the Design-mode toggle too — SceneVizBar
  // is mounted for the public compare dock as well as the owner's editor, and
  // how the room is DRAWN is no more a document mutation than which field is
  // overlaid on it.
  'SET_RENDER_MODE',
  'SET_COMPARE',
  'SET_MODAL_FREQ',
  'SET_MODAL_VIEW',
  'SET_REFLECTION_FILTER',
  'SET_VIZ_STATUS',
  'SET_ACTIVE_TIER',
  'SET_UNITS',
  'SET_PIPELINE',
]);

export function isViewOnlyEditorAction(type: EditorAction['type']): boolean {
  return VIEW_ONLY_EDITOR_ACTIONS.has(type);
}
